import { Add, Edit } from "@mui/icons-material";
import { useLocation } from "react-router-dom";

import { IFeatures } from "../../utils/interfaces";
import { useSessionContext } from "../../contexts/SessionContext";
import { CreateQuestionnarie } from "./CreateQuestionnarie";
import QuestionnaireBuilderPage from "src-next/applications/mvp/pages/QuestionnaireBuilderPage";
import { useOrganizationContext } from "@/contexts/OrganizationContext";
import { currentFeatures } from "@/configs/Settings";

/**
 * Configura a página de criação/edição de questionários clínicos.
 * Por enquanto apenas fornece um container vazio para o form builder.
 */
export function useCreateQuestionnarie() {
  const { state } = useLocation();
  const { access } = useSessionContext();
  const { organization } = useOrganizationContext();

  const configs: IFeatures = {
    active: access?.type === "professional",
    path: "/questionnaireBuilder",
    icon: state?.id ? Edit : Add,
    text: state?.id ? "Editar questionário" : "Criar questionário",

    subitem: true,
    parent: "Protocolos clínicos",

    sideMenu: true,
    sideMenuIndex: 0,

    component: () => (
      <QuestionnaireBuilderPage organizationId={organization?.id || ""} />
    ),
  };

  return configs;
}
